import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const LogoutIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M1.25 12.667V3.33301C1.25009 2.78059 1.46973 2.25098 1.86035 1.86035C2.25098 1.46973 2.78059 1.25009 3.33301 1.25H6C6.41421 1.25 6.75 1.58579 6.75 2C6.75 2.41421 6.41421 2.75 6 2.75H3.33301C3.17842 2.75009 3.03022 2.81158 2.9209 2.9209C2.81158 3.03022 2.75009 3.17842 2.75 3.33301V12.667C2.75009 12.8216 2.81158 12.9698 2.9209 13.0791C3.03022 13.1884 3.17841 13.2499 3.33301 13.25H6C6.41421 13.25 6.75 13.5858 6.75 14C6.75 14.4142 6.41421 14.75 6 14.75H3.33301C2.78059 14.7499 2.25098 14.5303 1.86035 14.1396C1.46973 13.749 1.25009 13.2194 1.25 12.667ZM9.86914 3.28809C10.1621 2.99548 10.6369 2.99532 10.9297 3.28809L15.1553 7.51465C15.4481 7.80755 15.4482 8.28232 15.1553 8.5752L11.0059 12.7236C10.713 13.0165 10.2382 13.0165 9.94531 12.7236C9.65283 12.4307 9.65257 11.9558 9.94531 11.6631L12.8145 8.79492H6.375C5.96082 8.79492 5.62505 8.45909 5.625 8.04492C5.625 7.63071 5.96079 7.29492 6.375 7.29492H12.8145L9.86914 4.34863C9.57627 4.05573 9.57624 3.58097 9.86914 3.28809Z"
      fill="currentColor"
    />
  </svg>
));
